import i18n from '@/locales'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_710'),
        action: obj => {
          this.createDialog('AddInvoiceInfoDialog', {
            data: [obj],
            onManager: this.onManager,
            refresh: this.refresh,
            type: 'edit',
          })
        },
      },
      {
        label: i18n.t('scope.text_675'),
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: i18n.t('scope.text_675'),
            name: i18n.t('scope.text_282'),
            onManager: this.onManager,
          })
        },
        meta: (obj) => this.$getDeleteResult(obj),
      },
    ]
  },
}
